import React, { useEffect, useState } from "react";
import { subscribeTx, getTxState } from "../../helper/Helper";

function TxnStatus() {
  const [tx, setTx] = useState(getTxState());
  
  useEffect(() => {
    const unsub = subscribeTx(setTx);
    return () => unsub();
  }, []);

  if (!tx.visible) return null;

  return (
    <>
      <div className="pendingTrxPopUp">
        <div style={{ width: 70, height: 70, margin: "15px auto" }}>
          <svg
            id="check"
            className={tx.status === "done" ? "ready" : "progressLoading"}
            viewBox="0 0 100 100"
            width="70"
            height="70"
          >
            <circle id="circle" cx="50" cy="50" r="46" />
            <polyline id="tick" points="25,55 45,70 75,33" />
          </svg>
        </div>

        <h3 className="good_times goldFont">
          {tx.status === "done"
            ? "Transaction Completed"
            : "Transaction in Progress"}
        </h3>
      </div>

      <div className="pendingTrxPopUpShadow"></div>
    </>
  );
}

export default TxnStatus;
